import React from "react";
import Uppy from "@uppy/core";
import Mixpanel from "mixpanel-browser";
import "@uppy/core/dist/style.css";
import "@uppy/url/dist/style.css";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import OneDrive from "@uppy/onedrive";
import Url from "@uppy/url";
import "@uppy/core/dist/style.css";
import "@uppy/url/dist/style.css";
import { Dashboard } from "@uppy/react";
import "@uppy/provider-views/dist/style.css";
import GoogleDrive from "@uppy/google-drive";
import Dropbox from "@uppy/dropbox";
import XHRUpload from "@uppy/xhr-upload";
import { userDocument } from "../../constants/path";
import { getHeader } from "../../utils/utils";
import constant from "../../constants/constants";
import { useDispatch } from "react-redux";
import { getDocuments } from "../../features/user-document/documentListingSlice";
// import Webcam from "@uppy/webcam";
// import Tus from "@uppy/tus";
// import DragDrop from "@uppy/drag-drop";
// import Instagram from "@uppy/instagram";
// import ScreenCapture from "@uppy/screen-capture";
// import Box from "@uppy/box";

function UppyComponent({ toggle, setSubCategories }) {
  const dispatch = useDispatch();
  const headers = getHeader();
  let projectData = JSON.parse(localStorage.getItem("_user"));

  const uppy = new Uppy({
    restrictions: {
      // maxFileSize: 1024 * 1024 * 2, // 2 MB
      allowedFileTypes: [".pdf"],
    },
  })
    .use(GoogleDrive, {
      companionUrl: process.env.REACT_APP_COMPANION_URL,
    })
    .use(Dropbox, {
      companionUrl: process.env.REACT_APP_COMPANION_URL
    })
    .use(Url, {
      companionUrl: process.env.REACT_APP_COMPANION_URL,
      locale: {},
    })
    .use(OneDrive, {
      companionUrl: process.env.REACT_APP_COMPANION_URL,
    });
  // .use(Box, {
  //   companionUrl: "https://companion.uppy.io/",
  // })
  //   .use(Tus, {
  //     endpoint: "https://8bad-2401-4900-3e3c-83cb-7bc3-7867-8643-138e.in.ngrok.io/api/imageupload",
  // });

  const data = new FormData();

  data.append("project_uuid", projectData?.projects[0]?.uuid);
  data.append("type", "doc");

  uppy.on("file-added", (file) => {
    uppy.setFileMeta(file.id, {
      type: "doc",
      project_uuid: projectData?.projects[0]?.uuid,
    });
  });

  uppy.use(XHRUpload, {
    id: "XHRUpload",
    endpoint: constant.baseURL + userDocument.UPLOAD_DOCUMENT,
    method: "post",
    formData: true,
    fieldName: "documents",
    headers: headers.headers,
  });

  uppy.on("complete", (result) => {
    // const httpStatus = response.status; // HTTP status code
    // const httpBody = response.body; // extracted response data
    Mixpanel.track("Document upload Button Clicked", {
      Page: "Upload document page",
    });
    // if (httpStatus === OK) {
    // showSuccess(httpBody.message);
    setSubCategories("Documents");
    dispatch(
      getDocuments({
        perPage: 10,
        page: 1,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    );
    toggle();
    // }
  });

  // uppy.on("file-added", (file) => {
  //   data.append("documents", file.data);
  //   uppy.setFileMeta(file.id, { data: data });
  //   uppy.addMeta(file.id, data);
  //   console.log(data)
  //   data.append("project_uuid", projectData?.projects[0]?.uuid);
  //   data.append("type", "doc");
  //   getLog(data);
  // });

  return (
    <>
      <h4>Import From</h4>
      <Dashboard
        uppy={uppy}
        plugins={[
          "GoogleDrive",
          "Dropbox",
          "Url",
          "OneDrive",
          // "Box",
          //"XHRUpload",
          // "Tus",
        ]}
      />
    </>
  );
}

export default UppyComponent;
